import * as React from 'react';

type Props = React.ElementProps<'img'>;

export default function Image(props: Props) {
  return <img {...props} />;
}
